import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import InputField from '../../../components/input-field/InputField';
import ValidationService from '../../../services/ValidationService';
import _ from 'lodash';
import CodeEditor from '../../../components/code-editor/CodeEditor';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
import Dropdown from '../../../components/dropdown/Dropdown';
import './script-endpoint-form.css';
import SmallJSONEditor from '../../../components/small-json-editor/SmallJSONEditor';
import TestRunnerModal from '../../../components/test-runner-modal/TestRunnerModal';
import SampleRequestCard from '../../../components/sample-request-card/SampleRequestCard';
import CommonService from '../../../services/CommonService';
import AppConfigService from '../../../services/AppConfigService';
import TrackingService from '../../../services/TrackingService';
const VS = new ValidationService();
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();
const ACS = new AppConfigService();
const TS = new TrackingService();

class ScriptEndpointForm extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			name: '',
			script: 'function script (foo) {\n\treturn foo;\n}',
			params: ['foo'],
			errors: [],
			endpoint: this.props.endpoint,
			async: false,
			runningTest: false,
			requestParams: {
				'mm-request-param-foo': {
					type: 'string',
					value: '',
					required: false
				}
			},
			paramFields: {
				foo: {
					type: 'string',
					value: '',
					required: false
				}
			},
			validJS: false
		};
		if (this.props.endpoint) {
			this.setupExisting();
		}
		this.autoBind(['onTestScript', 'buildTemplate', 'buildTestValues', 'handleEditorChange']);
	}

	componentDidMount() {}

	componentWillUnmount() {}

	setupExisting = () => {
		let ep = this.props.endpoint;
		this.data.name = ep.name;
		this.data.script = ep.configuration.script;
		if (this.data.name.length > 0) {
			this.data.validJS = true;
		}
		if (ep.templates) {
			this.data.requestParams = {};
			this.data.paramFields = {};
			this.data.params = Object.keys(ep.templates);
			_.forEach(this.data.params, param => {
				let tpl = ep.templates[param];
				this.data.paramFields[param] = {
					required: tpl.required,
					type: tpl.type
				};
				this.data.paramFields[param].value = tpl.default;
				if (tpl.type === 'object' || tpl.type === 'array') {
					this.data.paramFields[param].value = JSON.stringify(tpl.default);
				}
				if (tpl.type === 'boolean') {
					this.data.paramFields[param].label = typeof tpl.default === 'boolean' ? tpl.default.toString() : 'None';
					this.data.paramFields[param].value = Boolean(tpl.default);
				}
				if (tpl.type === 'contextHeader' && tpl.key) {
					this.data.paramFields[param].headerKey = tpl.key;
				}
				let name = `mm-request-param-${param}`;
				this.data.requestParams[name] = this.parseJson(JSON.stringify(this.data.paramFields[param]));
				this.data.requestParams[name].value = '';
			});
		} else {
			this.data.requestParams = {};
			this.data.paramFields = {};
			this.data.params = [];
		}
	};

	parseJson = val => {
		try {
			return JSON.parse(val);
		} catch (e) {
			console.error(e);
			return undefined;
		}
	};

	buildTemplate() {
		let tpl = {};
		let keys = Object.keys(this.data.paramFields);
		_.forEach(keys, param => {
			let pd = this.data.paramFields[param];
			let item = {
				required: pd.required,
				type: pd.type
			};
			if (pd.value !== undefined) {
				item.default = pd.value;
				if (pd.type === 'array' && pd.value.length > 0) {
					let cvt = `{"arr":${pd.value}}`;
					let obj = this.parseJson(cvt);
					item.default = obj.arr;
				} else if (pd.type === 'array') {
					delete item.default;
				}
				if (pd.type === 'object' && pd.value.length > 0) {
					item.default = this.parseJson(pd.value);
				} else if (pd.type === 'object') {
					delete item.default;
				}
				if (pd.type === 'number') {
					item.default = Number(pd.value);
				}
			}
			if (pd.claim) {
				item.claim = pd.claim;
			}
			if (pd.headerKey) {
				item.key = pd.headerKey;
			}
			tpl[param] = item;
		});
		return tpl;
	}

	buildTestValues() {
		let test = {};
		let keys = Object.keys(this.data.requestParams);
		_.forEach(keys, param => {
			let name = param.replace('mm-request-param-', '');
			let rd = this.data.requestParams[param];
			if (rd.value !== undefined) {
				test[name] = rd.value;
				if (rd.type === 'array' && rd.value.length > 0) {
					let cvt = `{"arr":${rd.value}}`;
					let obj = this.parseJson(cvt);
					test[name] = obj.arr;
				} else if (rd.type === 'array') {
					delete test[name];
				} else if (rd.type === 'number' && rd.value.length > 0) {
					test[name] = Number(rd.value);
				}
				if (rd.type === 'object' && rd.value.length > 0) {
					test[name] = this.parseJson(rd.value);
				}
				if (rd.type === 'number' && rd.value.length === 0) {
					delete test[name];
				}
				if (rd.type === 'userInfo' && rd.value.length <= 0) {
					delete test[name];
				}
				if (rd.type === 'contextHeader') {
					delete test[name];
				}
			}
		});
		return test;
	}

	getHeaders = () => {
		let headers = {};
		let keys = Object.keys(this.data.paramFields);
		_.forEach(keys, param => {
			let pd = this.data.paramFields[param];
			if (pd.type === 'contextHeader') {
				headers[pd.headerKey] = pd.value || this.data.requestParams[`mm-request-param-${param}`].value;
			}
		});
		if (Object.keys(headers).length > 0) {
			return { headers: { 'X-Mad-Context': JSON.stringify(headers) } };
		}
		return undefined;
	};

	toggleTestRunner = () => {
		this.setData('runningTest', !this.data.runningTest);
	};

	onTestScript() {
		let testData = this.buildTestValues();
		testData._async = this.data.async ? true : false;
		return connect.testEndpoint(
			{
				endpoint: {
					configuration: {
						script: this.data.script
					},
					type: 'script',
					version: 2,
					templates: this.buildTemplate()
				},
				testValues: testData
			},
			this.getHeaders()
		);
	}

	onSaveScript = () => {
		if (this.data.endpoint) {
			connect
				.updateEndpoint({
					_id: this.data.endpoint._id,
					name: this.data.name,
					type: 'script',
					version: 2,
					templates: this.buildTemplate(),
					configuration: {
						script: this.data.script
					}
				})
				.then(res => {
					RS.showSuccess();
					TS.track('Saved_Endpoint');
					ACS.populateEndpoint(res.data);
				})
				.catch(err => {
					RS.smartError(err);
				});
		} else {
			connect
				.createEndpoint({
					name: this.data.name,
					type: 'script',
					templates: this.buildTemplate(),
					version: 2,
					configuration: {
						script: this.data.script
					}
				})
				.then(res => {
					RS.showSuccess();
					this.setData('endpoint', res.data);
					ACS.populateEndpoint(res.data);
					TS.track('Saved_Endpoint');
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	handleEditorChange(newValue) {
		let decorations = this.editor.getModel().getAllDecorations();
		let errors = decorations
			.filter(decorations => {
				return decorations.options.className === 'redsquiggly';
			})
			.map(e => e);
		this.observe(() => {
			this.data.script = newValue;
			this.data.errors = errors;
			this.data.validJS = errors.length <= 0 && this.data.name.length > 0;
			this.data.params = CS.extractScriptParams(newValue);
			let newParamFields = {};
			_.forEach(this.data.params, param => {
				if (!this.data.paramFields[param]) {
					newParamFields[param] = {
						type: 'string',
						value: '',
						required: false
					};
				} else {
					newParamFields[param] = this.data.paramFields[param];
				}
			});
			this.data.paramFields = newParamFields;
			let params = Object.keys(this.data.paramFields);
			let requestFields = {};
			_.forEach(params, param => {
				if (param) {
					let name = `mm-request-param-${param}`;
					if (!this.data.requestParams[name]) {
						requestFields[name] = this.parseJson(JSON.stringify(this.data.paramFields[param]));
					} else {
						requestFields[name] = this.data.requestParams[name];
					}
				}
			});
			this.data.requestParams = requestFields;
		});
		setTimeout(() => {
			let decorations = this.editor.getModel().getAllDecorations();
			let error = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
			this.observe(() => {
				this.data.validJS = error.length <= 0 && this.data.name.length > 0;
			});
		}, 1500);
	}

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'name' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data.validJS = this.data.errors.length <= 0 && value.length > 0;
			this.data.name = value;
		});
	};

	onParamObjectChange = (name, newValue) => {
		this.observe(() => {
			if (name.indexOf('mm-request-param-') >= 0) {
				let field = this.data.requestParams[name];
				field.value = newValue;
				this.data.requestParams[name] = field;
			} else {
				let field = this.data.paramFields[name];
				field.value = newValue;
				this.data.paramFields[name] = field;
			}
		});
	};

	onDefaultChange = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				let field;
				if (name.indexOf('mm-request-param-') >= 0) {
					field = this.data.requestParams[name];
				} else {
					field = this.data.paramFields[name];
				}
				if (evt.target.type === 'checkbox') {
					field.value = evt.target.checked;
					field.label = field.value.toString();
					field.key = Math.random();
				} else {
					field.value = evt.target.value;
				}
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name] = field;
				} else {
					this.data.paramFields[name] = field;
				}
			});
		}
	};

	onRequiredChanged = evt => {
		let name = evt.target.dataset.param;
		if (name) {
			this.observe(() => {
				let details = this.data.paramFields[name];
				if (details) {
					details.required = evt.target.checked;
					let req = this.data.requestParams[`mm-request-param-${name}`];
					req.required = evt.target.checked;
				}
			});
		}
	};

	onClearValue = evt => {
		evt.persist();
		if (evt.target.dataset.name.indexOf('mm-request-param-') >= 0) {
			if (this.data.requestParams[evt.target.dataset.name].type !== 'boolean') {
				this.onSetEmpty(evt);
			}
			setTimeout(
				evt => {
					let name = evt.target.dataset.name;
					if (name) {
						this.observe(() => {
							let field = this.data.requestParams[name];
							field.value = undefined;
							if (field.type === 'boolean') {
								field.label = 'None';
								field.value = false;
								field.key = Math.random();
							}
						});
					}
				},
				50,
				evt
			);
		} else {
			if (this.data.paramFields[evt.target.dataset.name].type !== 'boolean') {
				this.onSetEmpty(evt);
			}
			setTimeout(
				evt => {
					let name = evt.target.dataset.name;
					if (name) {
						this.observe(() => {
							let field = this.data.paramFields[name];
							field.value = undefined;
							if (field.type === 'boolean') {
								field.label = 'None';
								field.value = false;
								field.key = Math.random();
							}
						});
					}
				},
				50,
				evt
			);
		}
	};

	onSetEmpty = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name].value = '';
					this.data.requestParams[name].key = Math.random();
				} else {
					this.data.paramFields[name].value = '';
					this.data.paramFields[name].key = Math.random();
				}
			});
		}
	};

	onClaimChange = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name].claim = evt.target.value;
				} else {
					this.data.paramFields[name].claim = evt.target.value;
				}
			});
		}
	};

	onHeaderKeyChange = evt => {
		let name = evt.target.dataset.name;
		if (name) {
			this.observe(() => {
				if (name.indexOf('mm-request-param-') >= 0) {
					this.data.requestParams[name].headerKey = evt.target.value;
				} else {
					this.data.paramFields[name].headerKey = evt.target.value;
				}
			});
		}
	};

	onTypeChange = obj => {
		this.observe(() => {
			let details = this.data.paramFields[obj.param];
			if (details) {
				let req = this.data.requestParams[`mm-request-param-${obj.param}`];
				details.type = obj.value;
				req.type = obj.value;
				details.value = '';
				details.required = false;
				details.claim = '';
				details.headers = '';
				if (details.type === 'boolean') {
					details.label = 'None';
					details.value = false;
					details.key = Math.random();
					req.label = 'None';
					req.value = false;
					req.key = Math.random();
				}
				if (details.type === 'object' || details.type === 'array') {
					details.value = '';
					req.value = '';
				}
				if (details.type === 'userInfo' || details.type === 'contextHeader') {
					details.key = Math.random();
					req.key = Math.random();
				}
			}
		});
	};

	getTypeOptions = param => {
		return [
			{
				label: 'String',
				value: 'string',
				param: param
			},
			{
				label: 'Number',
				value: 'number',
				param: param
			},
			{
				label: 'Boolean',
				value: 'boolean',
				param: param
			},
			{
				label: 'Object',
				value: 'object',
				param: param
			},
			{
				label: 'Array',
				value: 'array',
				param: param
			},
			// { Can't figure out how to get this one to work on CS
			// 	label: 'User Info',
			// 	value: 'userInfo',
			// 	param: param
			// },
			{
				label: 'X-Mad-Context Header',
				value: 'contextHeader',
				param: param
			}
		];
	};

	buildTypeDefault = (details, param) => {
		switch (details.type) {
			case 'string': {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
						/>
						<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
							Set as empty
						</button>
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			case 'number': {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input className="text-input" type="number" placeholder="None" value={details.value} data-name={param} onChange={this.onDefaultChange} />
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			case 'object': {
				return (
					<SmallJSONEditor
						value={details.value}
						onChange={this.onParamObjectChange}
						className="param-editor"
						minLines={5}
						maxLines={10}
						returnName={param}
					/>
				);
			}
			case 'array': {
				return (
					<SmallJSONEditor
						value={details.value}
						onChange={this.onParamObjectChange}
						className="param-editor"
						minLines={5}
						maxLines={10}
						returnName={param}
					/>
				);
			}
			case 'boolean': {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input type="checkbox" checked={details.value} data-name={param} onChange={this.onDefaultChange} key={details.key + param} />
						<div className="value-label grow-1">{details.label}</div>
						<button className="btn grey vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			case 'userInfo': {
				return (
					<div className="inline-btn-input hbox vcenter default" key={details.key + param}>
						{param.indexOf('mm-request-param') < 0 && (
							<input
								className="text-input claim-input"
								type="text"
								placeholder="Claim"
								value={details.claim}
								data-name={param}
								onChange={this.onClaimChange}
							/>
						)}
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
							disabled={param.indexOf('mm-request-param') >= 0}
						/>
						<button
							className="btn inline-btn no-radius vbox hcenter vcenter"
							data-name={param}
							onClick={this.onSetEmpty}
							disabled={param.indexOf('mm-request-param') >= 0}
						>
							Set as empty
						</button>
						<button
							className="btn inline-btn  vbox hcenter vcenter"
							data-name={param}
							onClick={this.onClearValue}
							disabled={param.indexOf('mm-request-param') >= 0}
						>
							Clear
						</button>
					</div>
				);
			}
			case 'contextHeader': {
				return (
					<div className="inline-btn-input hbox vcenter default" key={details.key + param}>
						{param.indexOf('mm-request-param') < 0 && (
							<input
								className="text-input claim-input"
								type="text"
								placeholder="Key"
								value={details.headerKey}
								data-name={param}
								onChange={this.onHeaderKeyChange}
							/>
						)}
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
						/>
						<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
							Set as empty
						</button>
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
			default: {
				return (
					<div className="inline-btn-input hbox vcenter default">
						<input
							className="text-input"
							type="text"
							placeholder={details.value === '' ? 'Empty String' : 'None'}
							value={details.value}
							data-name={param}
							onChange={this.onDefaultChange}
						/>
						<button className="btn inline-btn no-radius vbox hcenter vcenter" data-name={param} onClick={this.onSetEmpty}>
							Set as empty
						</button>
						<button className="btn inline-btn  vbox hcenter vcenter" data-name={param} onClick={this.onClearValue}>
							Clear
						</button>
					</div>
				);
			}
		}
	};

	buildParamsInput = () => {
		let fields = [
			<div className="param-header hbox vcenter" key={0}>
				<div className="label name">name</div>
				<div className="label type">type</div>
				<div className="label grow-1">default value</div>
				<div className="label required">required</div>
			</div>
		];
		let params = Object.keys(this.data.paramFields);
		_.forEach(params, param => {
			if (param && param.length > 0) {
				let details = this.data.paramFields[param];
				fields.push(
					<div className="field-row hbox vcenter" key={param + '-field-row'}>
						<div className="name ellipse">{param}</div>
						<div className="type m-r-20">
							<Dropdown
								className="param-type-picker"
								value={details.type}
								handleChange={this.onTypeChange}
								name="type"
								options={this.getTypeOptions(param)}
							/>
						</div>
						{this.buildTypeDefault(details, param)}
						<div className="required">
							<input type="checkbox" checked={details.required} value={details.required} data-param={param} onClick={this.onRequiredChanged} />
						</div>
					</div>
				);
			}
		});
		return fields.length > 1 ? fields : [];
	};

	toggleAsync = () => {
		this.setData('async', !this.data.async);
	};

	render() {
		let { name, script, validJS, runningTest, async } = this.data;
		return (
			<div className={`script-endpoint-form ${this.props.className}`}>
				<div className="step-header">
					<h3>Script Endpoint</h3>
					<div className="desc-text">
						Script endpoints are endpoints that execute a JavaScript function. The arguments passed to that function are taken from the body of the
						endpoint execution request.
					</div>
				</div>
				<div className="endpoint-form panel animated fadeIn">
					<InputField
						label="Name"
						subText="Use only lowercase characters, numbers or hyphens."
						type="text"
						name="name"
						value={name}
						handleChange={this.onValueChange}
						disabled={this.props.endpoint ? true : false}
						required
						autoFocus
					/>
					<div className="label label--required">Script</div>
					<CodeEditor className="editor-content" language="javascript" value={script} onChange={this.handleEditorChange} registerTo={this} />
					<div className="config-ctn">
						<h3>Parameters configuration</h3>
						<div className="desc-text">
							To enforce the invocation of the endpoint with valid parameter values, define their type and specify whether they are required or not,
							in which case you can provide a default value to use.
						</div>
						{this.buildParamsInput()}
					</div>
					<SampleRequestCard
						requestParams={this.data.requestParams}
						buildRequestFields={this.buildTypeDefault}
						validTest={validJS}
						onTest={this.toggleTestRunner}
						async={async}
						toggleAsync={this.toggleAsync}
					/>
					<div className="btn-ctn">
						<button className="btn primary" disabled={!validJS} onClick={this.onSaveScript}>
							Save
						</button>
					</div>
				</div>
				<TestRunnerModal isOpen={runningTest} onClose={this.toggleTestRunner} runTest={this.onTestScript} async={async} />
			</div>
		);
	}
}

export default ScriptEndpointForm;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/script-endpoint-form/ScriptEndpointForm.js